import { Status } from '@phpcreation/frontend-components-react';
import React from 'react';

type Props = {};

const StatusPage = (props: Props) => {
  return (
    <Status
      fqcn_bui={{ Bundle: 'appBunlde', Unit: 'status', Interface: 'status' }}
    />
  );
};

export default StatusPage;
